import {
  Theme,
  TypographyVariant,
  WithTheme,
  interpolateRhythmMargin,
} from '@mint/core';
import { ButtonBase } from '../button-base';
import { ListItemProps } from './list-item-props';
import { ListItemText } from '../list-item-text';
import PropTypes from 'prop-types';
import React from 'react';
import { cx } from '@mint/core';
import styled from 'styled-components';

/**
 * List root class name.
 */
const ROOT_CLASS_NAME = 'list-item';

/**
 * Component to use.
 */
const DEFAULT_COMPONENT = 'li';

/**
 * List component implementation before styling.
 */
export const ListItemComponent = React.forwardRef<any, ListItemProps>(
  (props, ref): React.ReactElement => {
    const {
      button,
      children,
      className,
      color,
      component: Component = DEFAULT_COMPONENT,
      ...rest
    } = props;

    const componentProps = {
      className: cx(ROOT_CLASS_NAME, className),
      ...rest,
      ref,
    };

    if (button) {
      return (
        <ButtonBase component={Component} {...componentProps}>
          {children}
        </ButtonBase>
      );
    } else {
      return (
        <Component {...componentProps} color={color}>
          {children}
        </Component>
      );
    }
  },
);

ListItemComponent.displayName = 'ListItem';

export const ListItem = styled(ListItemComponent)`
  display: flex;
  padding: ${props => props.theme.ms(-2, -1, 'em')};

  ${ListItemText} {
    flex: 1;
  }
`;
